module.exports = __webpack_public_path__ + "media/images/bindingAccount/icon_google-c0008cb353c469a4eaeaac1a3e334d73.svg";